var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkflowsIf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "currentColor",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.788 1.955a.75.75 0 0 1 .75.75v7.371h1.027a5 5 0 0 1 5 5v4.648l1.011-1.115a.75.75 0 0 1 1.111 1.008l-2.123 2.34v.002h-.002l-.168.186a.744.744 0 0 1-.586.24.744.744 0 0 1-.587-.24l-2.293-2.528a.75.75 0 0 1 1.111-1.008l1.025 1.13v-4.663c0-1.933-1.531-3.337-3.5-3.5h-3.553c-2.035.135-3.5 1.567-3.5 3.5v4.673l1.034-1.14a.75.75 0 0 1 1.111 1.008l-2.293 2.527a.744.744 0 0 1-.587.242.744.744 0 0 1-.587-.241l-.168-.186h-.01v-.012l-2.115-2.33a.75.75 0 0 1 1.112-1.008l1.003 1.105v-4.638a5 5 0 0 1 4.743-4.993l.257-.007h1.027v-7.37a.75.75 0 0 1 .75-.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkflowsIf);
export default __webpack_public_path__ + "static/media/workflows-if.a26b5c9c7d0e638254106b62edc03d37.svg";
export { ForwardRef as ReactComponent };